import { CALENDAR_DAY_LOAD_PENDING } from './useCalendarDayLoad.constants'

export function getCalendarDayLoadState({ date, response }) {
  return response.date === date ? response : CALENDAR_DAY_LOAD_PENDING
}
